import React from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Box, Typography, Card } from "@mui/material";
import { useTranslation } from "react-i18next";

// Register chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const TeamChart = ({ chartData, max }) => {
  const { t } = useTranslation();

  return (
    <Card sx={{ p: 2, width: "100%", boxShadow: 2, borderRadius: 2 }}>
      <Typography variant="subtitle1" align="center" sx={{ mb: 1, fontWeight: "medium" }}>
        {t("user.myTeam.teamperformanceChart")}
      </Typography>
      <Box sx={{ width: "100%", height: 250 }}>
        <Bar
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: { display: false },
              tooltip: { enabled: true },
            },
            scales: {
              y: {
                beginAtZero: true,
                max: max,
                grid: { display: false },
                ticks: { font: { size: 10 } },
                title: {
                  display: true,
                  text: t("user.dashboards.result"),
                  font: { size: 12 },
                },
              },
              x: {
                grid: { display: false },
                ticks: { font: { size: 10 } },
              },
            },
            elements: {
              bar: {
                borderWidth: 1,
                borderRadius: 6,
              },
            },
          }}
        />
      </Box>
    </Card>
  );
};

TeamChart.propTypes = {
  chartData: PropTypes.object.isRequired,
  max: PropTypes.number.isRequired,
};

export default TeamChart;
